/**
 * Central API client. Adds JWT to all requests so backend RBAC can enforce role checks.
 * baseURL is set from REACT_APP_API_URL so you only change it in .env when hosting.
 * Import this file once in index.js so the interceptor is registered for all axios usage.
 */
import axios from 'axios';
import { API_BASE } from './config';

axios.defaults.baseURL = API_BASE;

axios.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem('user');
    if (raw) {
      const user = JSON.parse(raw);
      if (user?.token) {
        config.headers.Authorization = `Bearer ${user.token}`;
      }
    }
  } catch (_) {}
  return config;
});

axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes('/api/auth/login')) {
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default axios;
